<table class="static-table full-width {{ app }}" cellspacing="0">
  <thead>
    <tr>
      <th>Items</th>
      <th [ngStyle]="{ 'text-align': design2 ? 'center' : 'right' }">Quantity</th>
      @if (!isCharityApp) {
        <th style="text-align: right">Price</th>
      }
    </tr>
  </thead>
  <tbody>
    <tr>
      <td>Bags/boxes of clothes/housewares</td>
      <td [ngStyle]="{ 'text-align': design2 ? 'center' : 'right' }">
        <span>
          {{ specification.small }}
        </span>
      </td>
      @if (!isCharityApp) {
        <td></td>
      }
    </tr>
    @if (!isCharityApp && gratuity) {
      <tr>
        <td>Tip</td>
        <td></td>
        <td style="text-align: right">
          <span>{{ gratuity | currency }}</span>
        </td>
      </tr>
    }
    @if (!isCharityApp) {
      <tr class="total" class="primary-row top-border-row">
        <td colspan="2">Total</td>
        <td style="text-align: right">
          @if (isDonorApp) {
            <span>{{ paymentDetails?.total_amount | currency }}</span>
            @if (discountPaymentDetails?.total_amount > 0) {
              <span class="discounted">{{ paymentDetails?.total_amount + discountPaymentDetails.total_amount | currency }}</span>
            }
          } @else {
            <span>{{ paymentDetails?.total_amount + discountPaymentDetails?.total_amount | currency }}</span>
          }
        </td>
      </tr>
      @if (discountValid && discountPaymentDetails.total_amount > 0 && isCaptainApp) {
        <tr class="total" class="primary-row">
          <td colspan="2">Charity Pays</td>
          <td style="text-align: right">
            {{ discountPaymentDetails.total_amount | currency }}
          </td>
        </tr>
        <tr class="total" class="primary-row">
          <td colspan="2">Donor Pays</td>
          <td style="text-align: right">
            {{ paymentDetails.total_amount | currency }}
          </td>
        </tr>
      }
    }
  </tbody>
</table>
